export default "__VITE_ASSET__B2YDOhf0__"